import { Outlet, createFileRoute } from '@tanstack/react-router';
import { CapabilityGate } from '@/components/billing/CapabilityGate';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

function FormsAreaLayout() {
	return (
		<CapabilityGate capability="sales">
			<Outlet />
		</CapabilityGate>
	);
}

export const Route = createFileRoute('/_authenticated/_app/forms')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({ context, anyOf: ['forms.read.own', 'forms.read.all'], redirectTo: '/dashboard' }),
	component: FormsAreaLayout,
});
